import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import {
  BASE_URL,
  GOTOPRODUCTDETAILS_URL_LOCAL,
  HOME_URL_LOCAL,
  ORDERS_URL_LOCAL,
  PRODUCT_DETAILS,
} from "../../utility/BaseUrl";

const OrdersDetails = () => {
  const { tracking_code } = useParams();
  const { state } = useLocation();

  const items = state?.items || [];

  return (
    <>
      <div className="pagetitle ">
        <ol className="breadcrumb">
          <li>
            <Link to={HOME_URL_LOCAL}> خانه </Link>
          </li>
          <li>
            <Link to={ORDERS_URL_LOCAL}> سفارش‌ها </Link>
          </li>
          <li className="active font-weight-bold"> محصولات فاکتور </li>
        </ol>
        <h3> محصولات سبد خرید - کد رهگیری: {tracking_code} </h3>
      </div>
      <div className="content-wrapper no-sidebar ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12"></div>

            <div className="col-xs-12 margin-top-sm">
              <div className="table-responsive">
                <table className="table table-crud table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>نام محصول</th>
                      <th>تعداد</th>
                      <th>قیمت کل</th>
                      <th>رنگ</th>
                      <th>تصویر</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.product.product_name}</td>
                        <td>{item.qty}</td>
                        <td>{item.pay_amount}</td>
                        <td>
                          <div
                            style={{
                              width: "20px",
                              height: "20px",
                              backgroundColor:
                                item.product.inventory_of_product.color,
                            }}
                          />
                        </td>
                        <td>
                          <img
                            src={BASE_URL + item.product.product_cover}
                            alt={item.product.product_cover_alt}
                            title={item.product.product_cover_title}
                            style={{ width: "50px", height: "50px" }}
                          />
                        </td>
                        <td>
                          <Link
                            to={GOTOPRODUCTDETAILS_URL_LOCAL(item.product.slug)}
                            className="btn btn-sm btn-primary"
                          >
                            {" "}
                            مشاهده{" "}
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrdersDetails;
